import React from "react";
import "./Book_A_Session.css";
import Common_Title from "../common/common-title/Common_Title";
import Booking_Form from "./booking-form/Booking_Form";
import Instructions from "./instructions/Instructions";

const Book_A_Session = () => {
  return (
    <section className="Book_A_Session">
      <div className="container">
        <Common_Title title="Complete the form to proceed" />
        <Booking_Form />
      </div>
    </section>
  );
};

export default Book_A_Session;
